import {Permission} from './models';

export interface Role {
  id: number;
  name: string;
  guard_name: string;
  permissions: Array<any>;
  created_at: any;
  updated_at: any;
  deleted_at: any;
}

/** Internal roles are Nexxen staff; external ones are the partner roles (Admin/Trader/Viewer). */
export enum UserRoleType {
  INTERNAL = 'INTERNAL',
  EXTERNAL = 'EXTERNAL'
}

export interface RoleJava {
  createdAt: string;
  deletedAt: string;
  id: number;
  name: string;
  roleType?: UserRoleType;
  permissions: Permission[];
  updatedAt: string;
}
